<template>
	<div id="app">
		<router-view v-if="isRouterAlive"/>
	</div>
</template>

<script>
import './assets/iconfont/iconfont.css';
export default {
	name: 'app',
	provide () {
		return {
			reload: this.reload
		};
	},
	data () {
		return {
			msg: '',
			isRouterAlive: true
		};
	},
	methods: {
		reload () {
			// this.isRouterAlive = false;
			// this.$nextTick(() => (this.isRouterAlive = true));
		}
	}
};
</script>

<style>
	html, body {
		width: 100%;
		height: 100vh;
		background: #fff;
		min-width: 1366px;
	}
	.map-html{
		min-width: 100vw;
	}
	.map-html body {
		min-width: 100vw;
	}
	* {
		padding: 0;
		margin: 0;
	}
	a {
		color: #888;
	}
	a:link, a:active, a:hover {
		color: #5572f1;
	}
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/*text-align: center;*/
		color: #2c3e55;
	}
</style>



// WEBPACK FOOTER //
// main/App.vue